import { useAuthContext } from './context';

/**
 * Sair da conta. Em caso de sucesso a sessão e o cache são limpos e `RequireAuth` leva a pessoa
 * ao /login. Em caso de falha (ex.: sem rede) a sessão continua e `error` explica; tentar de novo
 * é só chamar `logout` outra vez. Chamadas enquanto `pending` são ignoradas.
 */
export function useLogout(): { logout: () => void; pending: boolean; error: string | null } {
  const { logout, logoutStatus } = useAuthContext();
  return { logout, pending: logoutStatus.pending, error: logoutStatus.error };
}
